/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MergedCardTransactionDetailEvidenceListInnerWarnings
 */
export interface MergedCardTransactionDetailEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerWarnings
     */
    'detectedDpi'?: MergedCardTransactionDetailEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerWarnings
     */
    'calculatedDpi'?: MergedCardTransactionDetailEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerWarnings
     */
    'colorGradation'?: MergedCardTransactionDetailEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerWarnings
     */
    'heightMillis'?: MergedCardTransactionDetailEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerWarnings
     */
    'widthMillis'?: MergedCardTransactionDetailEvidenceListInnerWarningsWidthMillisEnum;
}

export const MergedCardTransactionDetailEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerWarningsDetectedDpiEnum = typeof MergedCardTransactionDetailEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerWarningsDetectedDpiEnum];
export const MergedCardTransactionDetailEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerWarningsCalculatedDpiEnum = typeof MergedCardTransactionDetailEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerWarningsCalculatedDpiEnum];
export const MergedCardTransactionDetailEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerWarningsColorGradationEnum = typeof MergedCardTransactionDetailEvidenceListInnerWarningsColorGradationEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerWarningsColorGradationEnum];
export const MergedCardTransactionDetailEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerWarningsHeightMillisEnum = typeof MergedCardTransactionDetailEvidenceListInnerWarningsHeightMillisEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerWarningsHeightMillisEnum];
export const MergedCardTransactionDetailEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerWarningsWidthMillisEnum = typeof MergedCardTransactionDetailEvidenceListInnerWarningsWidthMillisEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerWarningsWidthMillisEnum];


